var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stretch d-flex",staticStyle:{"background":"white"}},[_c('h1',{staticClass:"m-auto",staticStyle:{"font-size":"4rem"}},[_vm._v(" "+_vm._s(_vm.displayValue)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }